<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>管理员列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.companyCode" placeholder="请选择企业" filterable>
					<el-option key="" label="请选择企业" value=""></el-option>
					<el-option v-for="item in companyKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				&nbsp;&nbsp;
				<el-input v-model="query.userName" placeholder="用户名" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="companyCode" label="企业名称" :formatter="companyCodeFormat"></el-table-column>
                <el-table-column prop="userName" label="用户名"></el-table-column>
				<el-table-column prop="status" label="状态" :formatter = "statusFormat"></el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-form-item label="企业" prop="companyCode">
                    <el-select v-model="form.companyCode" placeholder="请选择企业" :disabled="isDisabled">
						<el-option key="" label="请选择企业" value=""></el-option>
						<el-option v-for="item in companyKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item label="用户名" prop="userName">
                    <el-input v-model="form.userName" maxlength="100" :disabled="isDisabled"></el-input>
                </el-form-item>
				<el-form-item label="密码" prop="password" v-if="!form.id">
                    <el-input v-model="form.password" type="password" maxlength="18"></el-input>
                </el-form-item>
				<el-form-item label="确认密码" prop="passwordConfirm" v-if="!form.id">
                    <el-input v-model="form.passwordConfirm" type="password" maxlength="18"></el-input>
                </el-form-item>
				<el-form-item label="状态" prop="status">
                    <el-select v-model="form.status" placeholder="请选择状态">
						<el-option key="" label="请选择"></el-option>
						<el-option key=false label="禁用" :value=false></el-option>
						<el-option key=true label="启用" :value=true></el-option>
					</el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchUserData, saveUser, deleteAdmin, getUser, getApplyCompanyList } from '../../../api/index';
export default {
    name: 'admin',
    data() {
		let validatePass = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入新密码'));
			} else if (value.toString().length < 6 || value.toString().length > 18) {
				callback(new Error('密码长度为6 - 18个字符'))
			} else {
				callback();
			}
		};
		let validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.form.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
        return {
            query: {
                companyCode: '',
                userName: '',
                pageNum: 1,
                pageSize: 10
            },
			companys:{},
            tableData: [],
            multipleSelection: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			companyKV:[],
			rules: {
                companyCode: [{ required: true, message: '请选择管理员所属企业', trigger: 'blur' }],
                userName: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
				password: [{ required: true, validator:validatePass, trigger: 'blur' }],
				passwordConfirm: [{ required: true, validator: validatePass2, trigger: 'blur' }],
				status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
            },
			controll:{}
        };
    },
    created() {
		this.controll = getControll("admin");
		this.getApplyCompany();
        this.getData();
    },
    methods: {
		//状态格式化
		statusFormat(row, column, cellValue) {
			if (cellValue == '0') {
				return '禁用';
			} else {
				return '启用';
			}
		},
		companyCodeFormat(row, column, cellValue) {
			return this.companys[cellValue];
		},
		//获取企业列表
		getApplyCompany() {
			getApplyCompanyList().then(res => {
				if (res.code == 0 ) {
					this.companyKV = res.data;
					for (var i = 0; i < this.companyKV.length; i++) {
						this.companys[this.companyKV[i].key] = this.companyKV[i].value;
					}
				} else {
					this.$message.error("获取企业列表失败！" + res.message);
				}
			})
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchUserData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAdmin([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAdmin(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.isDisabled = false;
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            //this.form = row;
			this.isDisabled = true;
			this.title = "编辑";
			getUser(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveUser(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
